export default "__VITE_ASSET__5dd93ba5__"